export interface ValidationError {
  code: string;
  detail?: string;
  source?: {
    pointer?: string;
  };
  meta?: {
    supplier_id?: string;
    supplier_name?: string;
  };
}

export interface ValidationErrors {
  errors?: ValidationError[];
}

export type GenericAPIError<T = string> = ResponseError<{
  errors: {
    code: T;
  }[];
}>;

export class ResponseError<TData = unknown> extends Error {
  response: Response;
  request: Request;
  data: TData;
  status: number;

  constructor(res: Response, data: TData, request: Request) {
    super(`${request.method} ${request.url} failed with status ${res.status} – ${res.statusText}`);
    this.data = data;
    this.response = res;
    this.status = res.status;
    this.request = request;
    this.name = 'ResponseError';
  }
}

export const isResponseError = <Data = unknown>(error: unknown): error is ResponseError<Data> =>
  error instanceof ResponseError;

export const isValidationError = (error: ResponseError): error is ResponseError<ValidationErrors> =>
  error.data !== null && typeof error.data === 'object' && 'errors' in error.data;

export class SensitiveActionCancelledError extends Error {
  override name = 'SensitiveActionCancelledError';
}
